import styled, { css } from 'styled-components/macro';

export const VideoPlayerWrapper = styled.div`
  height: 100%;
  position: relative;

  .react-player {
  }
`;

export const ControllPanel = styled.div`
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Seek = styled.input`
  width: 100%;
  cursor: pointer;
`;

export const PlayedProgress = styled.div``;

export const LoadedProgress = styled.div``;

export const Mutted = styled.div`
  display: flex;
  align-items: center;
  
  input {
    cursor: pointer;
  }
`;

export const PlayButton = styled.div`
  border: none;
  background: none;
  cursor: pointer;
`;

export const ReactPlayerContainer = styled.div`
  position: relative;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
  height: max-content;
`;

export const PlayerControlRow = styled.div`
  display: flex;
  align-items: center;
  //justify-content: center;
  gap: 16px;
  width: calc(100% - 100px);
  padding: 0 16px;
`;

export const ShowDropdownBtn = styled.div`
  color: #ffffff;
  font-size: 12px;
  cursor: pointer;
`;

export const SpeedButtons = styled.div`
  position: absolute;
  width: 50px;
  right: 18px;
  bottom: 30px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Dropdown = styled.div`
  width: 100%;
  
  button {
    background: none;
    border: none;
    padding: 0;
  }
`;

export const DropdownElement = styled.div`
  position: relative;
  display: flex;
  
  i {
    position: absolute;
    right: 0;
    font-size: 10px;
    line-height: 16px;
  }
`

export const SpeedButton = styled.button<{ active: boolean }>`
  color: #FFFFFF;
  cursor: pointer;
  height: 16px;
  
  ${(props) => (props.active ? css`
    &:before {
      
    }
  ` : css`
    opacity: 0.7;
  `)}
`;


export const VolumeControl = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;
`

export const Volume = styled.div`
  display: flex;
  align-items: center;
  
  input {
    cursor: pointer;
  }
`;


export const VideoPlayerContainer = styled.div<{thumbnail?: boolean}>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  
  ${props => props.thumbnail && css`
    .plyr__controls, .plyr__control {
      display: none !important;
    }
    pointer-events: none;
    touch-action: none;
  `}
`